// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3mObx","button":"Header_button__3Lscu","downloadButton":"Header_downloadButton__2Mbfw","camera":"Header_camera__3ZP6a"};